export default function Footer() {
  const scrollTo = (href: string) => {
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <footer className="bg-[#1A0F0A] border-t border-[#C9A961]/20 py-16">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="flex flex-col items-center text-center mb-12">
          {/* Logo */}
          <img
            src="/bp-logo.png"
            alt="BP Crown Logo"
            className="h-14 w-14 object-contain mb-4 opacity-90"
          />
          <h3
            className="font-serif text-2xl text-[#FAF7F2] mb-2"
            style={{ fontFamily: "'Cormorant Garamond', serif" }}
          >
            Bea Pate
          </h3>
          <p
            className="text-[11px] uppercase tracking-[0.3em] text-[#C9A961]"
            style={{ fontFamily: "'Lato', sans-serif" }}
          >
            Faith &bull; Purpose &bull; Creativity &bull; Impact
          </p>
        </div>

        {/* Nav links */}
        <div className="flex flex-wrap justify-center gap-8 mb-12">
          {[
            { label: "About", href: "#about" },
            { label: "Work", href: "#work" },
            { label: "Education", href: "#education" },
            { label: "Contact", href: "#contact" },
          ].map((link) => (
            <button
              key={link.label}
              onClick={() => scrollTo(link.href)}
              className="text-[12px] uppercase tracking-widest text-[#FAF7F2]/50 hover:text-[#C9A961] transition-colors duration-300 cursor-pointer whitespace-nowrap"
              style={{ fontFamily: "'Lato', sans-serif" }}
            >
              {link.label}
            </button>
          ))}
        </div>

        {/* Divider */}
        <div className="w-24 h-px bg-[#C9A961]/30 mx-auto mb-8" />

        {/* Bottom row */}
        <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
          <p
            className="text-[12px] text-[#FAF7F2]/30"
            style={{ fontFamily: "'Lato', sans-serif" }}
          >
            &copy; 2025 Beatrice Pate. All rights reserved.
          </p>

          {/* Social icons */}
          <div className="flex items-center gap-5">
            <a
              href="mailto:msbeatricepate@gmail.com"
              className="w-8 h-8 flex items-center justify-center text-[#FAF7F2]/40 hover:text-[#C9A961] transition-colors duration-300 cursor-pointer"
              aria-label="Email"
            >
              <i className="ri-mail-line text-lg" />
            </a>
            <a
              href="https://www.linkedin.com/in/beatricepate"
              target="_blank"
              rel="nofollow noopener noreferrer"
              className="w-8 h-8 flex items-center justify-center text-[#FAF7F2]/40 hover:text-[#C9A961] transition-colors duration-300 cursor-pointer"
              aria-label="LinkedIn"
            >
              <i className="ri-linkedin-line text-lg" />
            </a>
            <a
              href="https://github.com/beatricepate"
              target="_blank"
              rel="nofollow noopener noreferrer"
              className="w-8 h-8 flex items-center justify-center text-[#FAF7F2]/40 hover:text-[#C9A961] transition-colors duration-300 cursor-pointer"
              aria-label="GitHub"
            >
              <i className="ri-github-line text-lg" />
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
